import React from 'react';
import Page from './components/Page';
import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import step from './reducers';
import * as API from '../api';
import { error } from 'plugins/toastr';
import { getIsDirty } from './reducers/dirty';
import $ from 'jquery';
import { withCurrentReferer } from '../../../../../plugins/contextual-back';

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      console.log(key);
      return key.substring(4);
    })
    .filter(e => e !== null);

  store.dispatch({
    type: 'errors',
    payload: errors,
  });
}

function handleError(err, store) {
  console.log('Error attempting to save case', err);
  if (err.res.status === 400) {
    // Handling errors properly
    err.res.json().then(json => dispatchErrors(store, json));
  } else {
    error('Une erreur est survenue pendant la sauvegarde du dossier');
  }
}

export default function handleStep() {
  const middleware = [thunk];
  const enhancers = [];

  const root = document.getElementById('creation-step-4');
  const id = root.getAttribute('data-id');
  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#creation-step-4 form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page id={parseInt(id, 10)} />
    </Provider>,
    root
  );

  const cleanDirty = () => $('#creation-step-4 form').removeClass('dirty');

  const prepareForm = state => ({
    ...state.form,
    lines: state.form.lines.map((line, index) => ({
      order: index + 1,
      ...line,
    })),
  });

  const saveForLaterButton = document.getElementById('bt-save-later');
  if (saveForLaterButton) {
    const id = saveForLaterButton.getAttribute('data-id');
    saveForLaterButton.onclick = () => {
      cleanDirty();
      API.saveForLater(id, prepareForm(store.getState())).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(err, store)
      );
    };
  }

  const saveAndGenerateButton = document.getElementById('bt-save-generate');
  if (saveAndGenerateButton) {
    const id = saveAndGenerateButton.getAttribute('data-id');
    saveAndGenerateButton.onclick = () => {
      cleanDirty();
      API.saveAndGenerate(id, prepareForm(store.getState())).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(err, store)
      );
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/index.js